function buildReminderRequest({ stage, approval, supplierId }) {
  const stageNum = Number(stage);
  const payload = { stage: stageNum };

  if (approval) {
    payload.approval = approval;
  }

  if ((stageNum === 3 || stageNum === 4) && supplierId) {
    payload.supplierId = String(supplierId);
  }

  return payload;
}

module.exports = {
  buildReminderRequest,
};
